module.exports= {
	t24_logo: require("./favicon.ico"),
	platform_logo: require("./platform_logo.png"),
	scc_titan_logo: require("./scc_titan_logoC.svg"),
	scc_titan_logo_bottom: require("./scc_titan_logoC_bottom.png"),
	sprite: require("./sprite.svg"),
	t24_logo_light_hd: require("./T24DefenceLogo_LightHD.png") 
};